(function () {
	document.addEventListener("DOMContentLoaded", () => {

		if (!document.body.classList.contains("home")) return;

		document.addEventListener("click", (event) => {

			const item = event.target;

			if (!item) return;

			if (handleAppDownload(item)) return;

			if (handlePredefinedSearch(item)) return;

			if (handleFaqsSelection(item)) return;

			if (handleViewAllFaqs(item)) return;

			if (handleViewCity(item)) return;
		});

		document.addEventListener("gtmGymSearchEvent", (event) => {
			const { searchQuery, selection } = event.detail;

			VgGtm.pushRegisterEventToDataLayer(
				'search',
				{},
				{ 
					event_category: 'buscador_home',
					event_detail: 'busqueda_manual',
					event_label: searchQuery,
					club_name: selection.api === 'store' ? selection.description : 'sin_seleccionar',
				}
			);
		});

		document.addEventListener("gtmLeadFormSubmit", async (event) => {
			if (!event.detail) return;

			const gtmData = {
				event_category: 'newsletter',
				event_detail: event.detail.success ? 'envio_ok' : 'envio_ko',
				event_label: event.detail.success ? 'envio_ok' : event.detail.error,
				club_name: VgGtm.formatGtmLabel(event.detail.gtm_data?.club_name),
				club_region: VgGtm.formatGtmLabel(event.detail.gtm_data?.club_region),
			}

			if (event.detail.success) {
				gtmData.email_hashed = event.detail.gtm_data?.email_hashed;
				gtmData.phone_hashed = event.detail.gtm_data?.phone_hashed;
			}

			VgGtm.pushRegisterEventToDataLayer(
					'form_interaction',
					{},
					gtmData
			);
		});

		function handlePredefinedSearch(item) {
			if (!item.classList.contains("vg-search-gym__input") && 
				!item.classList.contains("vg-search-gym_tag")) {
				return false;
			}

			if (item.classList.contains("vg-search-gym_tag")) {
				VgGtm.pushRegisterEventToDataLayer(
					'search',
					{},
					{ 
						event_category: 'buscador_home',
						event_detail: 'busqueda_predefinida',
						event_label: VgGtm.formatGtmLabel(item.textContent),
					}
				);
			}

			return true;
		}

		function handleAppDownload(item) {
			const appDownloadLink = item.closest('.vg-featured__cta-item a');
			if (!appDownloadLink) return false;

			const eventLabel = appDownloadLink.classList.contains('huawei-store') ? 'app_gallery' : appDownloadLink.classList[0].replace('\-', '_');

			VgGtm.pushRegisterEventToDataLayer(
				'click',
				{},
				{ 
					event_category: 'body',
					event_detail: 'vivagym_myapp',
					event_label: eventLabel,
				}
			);
			
			return true;
		}

		function handleFaqsSelection(item) {
			const faqGroup = item.closest('.vg-faqs__accordion-heading');

			if (!faqGroup) return false;
			if (item.getAttribute('aria-expanded') === 'false') return false;

			VgGtm.pushRegisterEventToDataLayer(
				'click',
				{},
				{ 
					event_category: 'desplegar_faq',
					event_detail: item.textContent,
					event_label: item.textContent,
				}
			);
			
			return true;
		}

		function handleViewAllFaqs(item) {
			const viewAllFaqs = item.closest('.vg-faqs__cta a');
			if (!viewAllFaqs) return false;

			VgGtm.pushRegisterEventToDataLayer(
				'click',
				{},
				{ 
					event_category: 'faqs',
					event_detail: 'ver_todas_las_faqs',
					event_label: 'ver_todas_las_faqs',
				}
			);

			return true;
		}

		function handleViewCity(item) {
			const cityLink = item.closest('.vg-featured-manual__item a');
			if (!cityLink) return false;

			const cityItem = item.closest('.vg-featured-manual__item');
			const cityTitle = cityItem.querySelector('.vg-featured-manual__item-title');
		
			VgGtm.pushRegisterEventToDataLayer(
				'click',
				{},
				{
					event_category: 'encuentra_tu_gimnasio',
					event_detail: VgGtm.formatGtmLabel(cityTitle.textContent),
					event_label: VgGtm.formatGtmLabel(cityLink.textContent),
				}
			);

			return true;
		}
	});
})();